import { DialogService, GridAction } from '@eforall/dashboard';
import { AccProspect } from '@interfaces';
import { AccApplicationDialog, PersonDialog, PersonDialogData } from '../../../../../../ui/widget';
import { AssignedStaffDialog, AssignedStaffDialogResult, EntrepreneurProspectDialog } from '../../../../../../ui/widget/dialog';
import { AdmissionsAreaService } from '../../../../admissions-area.service';

export function getActions(dialogService: DialogService, admissionsAreaService: AdmissionsAreaService) {

	const actions: GridAction<AccProspect>[] = [
		{
			iconClass: 'fa-regular fa-filter-list',
			label: 'View Prospect Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(EntrepreneurProspectDialog, { data: { personId: rows[0]!.personId, accProspectId: rows[0]!.accProspectId } }, 900, 750);
				await admissionsAreaService.reloadData(); // TODO reload data only if there is a change
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'Open Application Details',
			isEnabled: rows => !!rows.length && !!rows[0]!.accApplicationId,
			execute: async rows => {
				await dialogService.showCustom(AccApplicationDialog, { data: { accApplicationId: rows[0]!.accApplicationId } }, 900, 900);
				await admissionsAreaService.reloadData(); // TODO fix this to only call if there are changes
			}
		},
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View All Engagements',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: PersonDialogData = { personId: rows[0]!.personId, toEdit: false, tab: 'engagements' };
				await dialogService.showCustom(PersonDialog, { data: dialogData }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-plus',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (admissionsAreaService.canManageAdmissionsStaff()) return !!rows.length;
				return false;
			},
			execute: async rows => {
				const prospectName = rows[0]?.fullName;
				const staffId = rows[0]?.assignedToStaffId || 0;
				const action = await dialogService.showCustom(AssignedStaffDialog, {
					data: {
						headerText: prospectName!,
						staffId: staffId
					}
				}, 800, 300);

				const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
				if (result) {
					if (rows[0]?.accLeadId) {
						await admissionsAreaService.updateAssignedStaffForLead(rows[0]!.accLeadId, result.staffId);
					} else if (rows[0]?.accApplicationId) {
						await admissionsAreaService.updateAssignedStaffForApplication(rows[0]!.accApplicationId, result.staffId);
					}
					await admissionsAreaService.reloadData();
				}
			}
		},
	];

	return actions;
}